<template>
  <div class="client-app user-app">
    <div class="client-app-inc">
       <div class="container"> 
         <div class="row">
          <div class="col col-2 left-user-t" v-if="!isMobile">
            <div class="left-user">
              <p>Hoşgeldiniz</p>
              <h3 class="line-title">{{ user.username }}</h3>
              <div class="row buttons">
                  <div class="col">
                    <router-link :to="{ name: 'User', params: { section: 'deposit', payment: null } }" class="button primary">Para Yatır</router-link>
                  </div>
                  <div class="col">
                    <router-link :to="{ name: 'User', params: { section: 'withdraw', payment: null } }" class="button secondary">Para Çek</router-link>
                  </div>
              </div>
              <UserMenu :is_popup="is_popup"/>
            </div>
          </div>
          <div class="col col-8 user-center-t">
            <div class="content">
              <component v-if="!loading" :is="user_router"></component>
            </div>
          </div>
          <div class="col col-2 right-user-t" v-if="!isMobile">
            <div class="promotion-list">
              <p>Öne Çıkan</p>
              <h3 class="line-title">Promosyonlar</h3>
              <router-link v-show="key < 5" target="_blank" :to="{ name:'Promotions', params: { group: 'all', id: item.id }}" v-for="(item,key) in promotions" :key="key">
                <img :src="$store.state.main.cdn_url + item.image" width="100%">
              </router-link>
            </div>
          </div>
         </div>
       </div>
    </div>
  </div>
</template>

<script>
  import MobileShortCut from '../../components/Common/Header/MobileShortCut';
  import UserPopUpTop from '../../components/User/PopUpTop'
  import UserInfo from '../../components/User/Info'
  import UserMenu from '../../components/Common/User/UserMenu'
  import info from '../../views/User/Info'
  import coupons from '../../views/User/Coupons'
  import documents from '../../views/User/Documents'
  import history from '../../views/User/History'
  import bethistory from '../../views/User/BetHistory'
  import bhistory from '../../views/User/BetHistoryV2'
  import security from '../../views/User/Security'
  import send from '../../views/User/SendFriend'
  import messages from '../../views/User/Messages'
  import bonus from '../../views/User/Bonus'
  import deposit from '../../views/User/Payment/Deposit'
  import withdraw from '../../views/User/Payment/Withdraw'
  import status from '../../views/User/Payment/Status'
  export default{
    name: 'User',
    props:['is_popup'],
    data(){
      return{
        loading : false,
      }
    },
    computed:{
      user_router(){
        return this.$store.getters.getUserRouter;
      },
      promotions(){
        return this.$store.getters.getClientPromotions;
      },
      user(){
        return this.$user();
      },
    },
    metaInfo () {
      return {
        title: _.get(this.$user(), 'username', '') + ' | ' + _.get(this.$store.getters['getClientMeta'], 'main.title', ''),
      }
    },
    created(){
      if(this.$route.params.payment){
        this.loading = true;
      }
      this.$store.dispatch('wallet/initPendingTransaction')
      .then(response =>{
        if(this.$route.params.payment){
          this.loading = false;
        }
        return response
      })
    },
    components:{
      UserInfo,
      UserMenu,
      UserPopUpTop,
      MobileShortCut,
      coupons,
      documents,
      send,
      info,
      history,
      bethistory,
      bhistory,
      security,
      bonus,
      messages,
      deposit,
      withdraw,
      status
    }
  }
</script> 